import { render, staticRenderFns } from "./IBSRisk.vue?vue&type=template&id=ff0dcd28&scoped=true"
import script from "./IBSRisk.vue?vue&type=script&lang=js"
export * from "./IBSRisk.vue?vue&type=script&lang=js"
import style0 from "./IBSRisk.vue?vue&type=style&index=0&id=ff0dcd28&prod&lang=scss&scoped=true"
import style1 from "./IBSRisk.vue?vue&type=style&index=1&id=ff0dcd28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0dcd28",
  null
  
)

export default component.exports